<template>
  <div
    class="modal fade modal-update-salable"
    id="view_modal_update_salable"
    ref="view_modal_update_salable"
    data-backdrop="static"
    role="dialog"
    aria-labelledby="view_modal_update_salable"
    style="z-index: 1179;"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content border-0" ref="section">
        <div class="border-bottom border-bottom-1 modal-header py-2">
          <h6 v-show="isUpdateQuantity" class="modal-title" data-test="title-update-stock">{{ $t("Update Stock") }}</h6>
          <h6 v-if="isReserved" class="modal-title" data-test="title-reserved-qty-list">{{ $t("Reserved QTY List") }}</h6>
        </div>
        <div class="modal-body p-0">
          <div :class="isReserved? '' : 'content'">
            <div v-if="isload">
              <div class="content p-0">
                <placeholder-content is-load="true" />
              </div>
            </div>
            <div v-if="!isload">
              <div v-if="!hasPermission">
                <access-denied :isCloseSpan="true" />
              </div>
              <div v-else>
                <!-- Info Product -->
                <div :class="isReserved? 'content d-flex pb-0' : 'd-flex'">
                  <div class="images">
                    <img
                      class="images_box_info rounded"
                      :src="
                        productHeader.images[0] ||
                          $storeIndex.getImageGobalAssets('')
                      "
                      data-test="data-images"
                    />
                  </div>

                  <div class="pl-3">
                    <div class="d-flex line-height-1 my-0">
                      <router-link
                        :to="{
                          name: 't.a.products',
                          query: { productId: productHeader.id }
                        }"
                        target="_blank"
                        data-test="data-product-name"
                      >
                        <label class="font-13 height-normal">{{ productHeader.name }}</label>
                      </router-link>
                    </div>
                    <div class="line-height-1 my-0 d-flex font-12">
                      <label>
                        <span class="font-weight-bold text-sku">SKU: </span>

                        <span class="text-muted cursor-auto pl-1" data-test="data-sku">{{
                          productHeader.sku
                        }}</span>
                      </label>
                      <label class="ml-3">
                        <span class="font-weight-bold text-sku">
                          {{ $t("Barcode") }}:
                        </span>

                        <span class="text-muted cursor-auto pl-1" data-test="data-barcode">{{
                          productHeader.barcode || "-"
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Update Saleable -->
                <update-salable
                  v-show="isUpdateQuantity"
                  :warehouseLists_="warehouseLists"
                  :reserve_="productHeader.product_reserved"
                  :restock_="productHeader.product_restock"
                  data-test="section-update-salable"
                  @update-salable="handleSalableUpdate"
                />

                <!-- View Reserved -->
                <div v-if="warehouseLists.length > 0 && productHeader.product_reserved > 0">
                  <reserved v-show="isReserved " :products-id="reservedProductId" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!isload"
          class="modal-footer justify-content-center bg-light py-2"
        >
          <div class="d-flex justify-content-between">
            <a
              v-if="isReserved"
              class="btn btn-primary mr-2 text-white pointer"
              @click="switchPage('updateQuantity')"
              data-test="btn-back"
            >
              <i class="mr-2 fa-solid fa-arrow-left" /> {{ $t("Back") }}
            </a>
            <button
              type="button"
              class="ml-2 mr-2 btn btn-light"
              data-dismiss="modal"
              @click="closeModal()"
              data-test="btn-cancel"
            >
              {{ $t("Cancel") }}
            </button>
            <ladda
              v-if="hasPermission && isUpdateQuantity"
              :text="$t('Update')"
              @click="submit()"
              :loading="loadingSubmit"
              :btn-class="'btn btn-primary mr-2'"
              icon="<i class='fas fa-circle-check'></i>"
              data-test="btn-update"
              :disabled="!isValid"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service.js";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import Ladda from "@/plugins/Ladda.vue";
import "vue-popperjs/dist/vue-popper.css";
import numeral from "numeral";
import Cookies from "js-cookie";
import Select2 from "v-select2-component";
import UpdateSalable from "./UpdateSalable";
import Reserved from "./Reserved";
import { required, numeric, minValue, maxValue, helpers } from "vuelidate/lib/validators";

const numericWithNegative = helpers.regex('numericWithNegative', /^-?\d+(\.\d+)?$/)

export default {
  components: {
    PlaceholderContent,
    AccessDenied,
    Ladda,
    Select2,
    UpdateSalable,
    Reserved
  },
  props: {
    productUpdateSalable: {
      type: [Object, Array],
      default: undefined
    }
  },
  data() {
    return {
      isShowModal: false,
      isload: true,
      loadingSubmit: false,
      hasPermission: false,
      productUpdate: this.productUpdateSalable,
      productHeader: [],
      loading: false,

      wmsService: Cookies.get("WmsSevice"),
      warehouseId: "",
      warehouseLists: [],
      reservedProductId: [],
      editSalable: 0,
      isUpdateQuantity: true,
      isReserved: false,
      productLinkData: [],
      salable:0,
    };
  },
  filters: {
    formatNumberNotZero: function(value) {
      return numeral(value).format("0,0");
    }
  },

  methods: {
    handleSalableUpdate(salableAmount) {
      this.salable = salableAmount;
    },
    getTime() {
      let toDay = new Date();
      return moment(convertTimezone.utcToLocal(toDay)).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    isShowComponent() {
      this.$nextTick(() => {
        $("#view_modal_update_salable").modal("show");
        this.feedData();
      });
    },
    closeModal() {
      this.$store.dispatch("product/productUpdateSalable", {});
      this.$store.dispatch("product/isModalUpdateSalable", false);
      $("#view_modal_update_salable").modal("hide");
    },
    async feedData() {
      this.isload = true;
      try {
        let response = await Api.ProductV2.getProductUpdateSalable(
          this.productUpdate.productId,
          this.productUpdate.productType,
        );
        this.productHeader = await response.data.data;
        this.warehouseLists = await this.productHeader.stocks;
         this.warehouseLists = this.warehouseLists.map(item => ({
            ...item,
            ...(item.warehouse_id == this.productHeader.specific_warehouse ? { specific_warehouse: true } : {specific_warehouse: false })
          }));

        this.editSalable = Number(this.productHeader.quantity || 0);

        this.reservedProductId =
          (await this.productHeader.wms_products_link.length) > 0
            ? this.productHeader.wms_products_link
            : [this.productHeader.id];
        this.isload = false;
        this.hasPermission = true;
      } catch (err) {

        if(err.response.status == 403){
          this.isload = false;
          this.hasPermission = false;
        }else{
          this.$toastr.e(this.$t("Save failed, please try again"), "<span class='icon-blocked'></span>" + this.$t("Error"));
          this.closeModal();
        }
        
      }
    },
    async submit() {
      if (!this.isValid) return true;

      try {
        this.loadingSubmit = true;
        let payload = {};
        
        if (
          this.productHeader.type == "sync" ||
          this.productHeader.external_id ||
          this.productHeader.omni_link_id
        ) {

          this.openWebsocketUpdateQtyProductMkp();
          this.closeModal();
        }

        let sumSable = 0;
        let hesWarehouse = false;
        if (this.wmsService == 2 && this.warehouseLists.length > 0) {
          payload = {
            warehouses: this.warehouseLists.map(item => ({
              warehouse_id: item.warehouse_id,
              quantity: item.available_qty
            }))
          };
          sumSable = this.warehouseLists.reduce((total, item) => total + item.available_qty, 0);
          hesWarehouse = true;
          sumSable = sumSable - (this.productHeader.product_reserved + this.productHeader.product_restock);
        } else {
          payload = {
            quantity: this.editSalable
          };
          sumSable = this.editSalable;
          hesWarehouse = false;

        }

        let response = await Api.ProductV2.putProductUpdateSalable(
          this.productHeader.id,
          payload
        );

        if (!response || response.status >= 400) {
          console.log('response Error : ' , response);
          throw new Error( );
        }

        let updateSalable = {
          product_id: this.productHeader.id,
          product_link_id: this.productHeader.omni_link_id ,
          payload: payload,
          sumSable: this.editSalable,
          hesWarehouse: hesWarehouse
        }

        this.$store.dispatch("product/updateSalable", updateSalable);
      
        if (
          !(
            this.productHeader.type == "sync" ||
            this.productHeader.external_id ||
            this.productHeader.omni_link_id
          )
        ) {
          let description =
            '<p class="mb-0">' + this.$t("Edit On Hand Success.") + "</p>";

          let icon = "<span class='fa-solid fa-circle-check mr-2'></span>";
          this.$toastr.Add({
            type: "success",
            title: icon + this.$t("Success"),
            msg: this.$t(description),
            clickClose: true,
            position: "toast-top-right"
          });
        }
        
        this.$store.dispatch('product/isFeedDataProduct', true);
        this.$store.dispatch('product/isFeedDataProductList', true);
        
        
        this.closeModal();
      } catch (error) {
        this.$toastr.e(
          this.$t("Something went wrong. Please try again."),
          "<span class='icon-blocked'></span>" + this.$t("Error")
        );
      }

      this.loadingSubmit = false;
    },
    switchAlertAccessDenied() {
      const Swal = this.$swal;
      const self = this;
      Swal({
        imageUrl: require("@/assets/images/activities/icon-access-denied.png"),
        title: self.$t("Access Denied") + " !",
        html:
          self.$t("You do not have permission to access this page.") +
          "<br/>" +
          self.$t("If you feel this is a mistake, contact your admin."),
        confirmButtonText:
          '<i class="fa-solid fa-thumbs-up mr-1"></i>' + self.$t("OK"),
        customClass: {
          confirmButton: "btn btn-primary"
        },
        focusConfirm: false
      });
    },
    toastAlert(type = "", title = null, description = null) {
      let icon = "";
      switch (type) {
        case "warning":
          icon = "<span class='t-icon icon-checkmark3'></span>";
          break;
        case "error":
          icon = "<span class='fa-solid fa-times-circle mr-2'></span>";
          break;
        default:
          icon = "<span class='fa-solid fa-circle-check mr-2'></span>";
          break;
      }
      this.$toastr.Add({
        type: type,
        title: icon + this.$t(title),
        msg: this.$t(description),
        clickClose: true,
        position: "toast-top-right"
      });
    },
    openWebsocketUpdateQtyProductMkp() {
      let oldData = this.productHeader;
      let productLinkData = this.productHeader.product_link_data;
      const self = this;

      const listData = productLinkData.map(link => {
        return {
          product_name: link.name,
          channel: link.channel,
          channel_id:
            link.channel && link.channel.type && link.channel.type.id
              ? link.channel.type.id
              : "manual",
          channel_name:
            link.channel && link.channel.type && link.channel.type.name
              ? link.channel.type.name
              : "Manual Product",
          channel_logo:
            link.channel && link.channel.type && link.channel.type.logo
              ? link.channel.type.logo
              : self.$storeIndex.getImageGobalAssets("icon-gosell"),
          quantity: link.quantity > 0 ? link.quantity :0 ,
          barcode: link.barcode,
          product_id: link.id,
          sku: link.sku,
          model_external_id: link.external_id ? link.external_id : link.id
        };
      });

      let setDataProductLink = {
        qty: oldData.quantity,
        items: listData
      };

      this.$store.dispatch("product/isOpenModal", false);
      this.$nextTick(() => {
        this.$store.dispatch("product/isOpenModal", true);
        this.$store.dispatch(
          "product/listDataProgressBar",
          setDataProductLink
        );
      });
    },
    switchPage(page = "updateQuantity") {
      switch (page) {
        case "updateQuantity":
          this.isUpdateQuantity = true;
          this.isReserved = false;
          break;
        case "reserved":
          this.isUpdateQuantity = false;
          this.isReserved = true;
          break;
        default:
          this.isUpdateQuantity = false;
          this.isReserved = false;
          break;
      }
    }
  },
  mounted() {
    this.isShowComponent();
  },
  computed: {
    isValid() {
      return !this.$v.editSalable.$invalid
    }
  },
  validations() {
    return {
      editSalable: {
        required,
        numericWithNegative,
        maxValue: maxValue(9999999)
      }
    }
  },
};
</script>

<style scoped>
.fade {
  pointer-events: none !important;
}
.font-12 {
  font-size: 12px;
}
.height-normal {
    line-height: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/stock/ModalUpdateSalable.vue